// Func = limiting Scope for this file
var lastScrollTop = 0;

const allBoxes = document.getElementsByClassName('navigation-js');
const allBoxesLength = allBoxes.length;

const bookingBlock = document.getElementsByClassName('booking-js')[0];

//datepicker booking
var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0;

(function(){

	//menu gallery
	menuLinksInteraction();

	//is explorer
	function msieversion() {

		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");
		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
		{
			const image_fit = document.getElementsByTagName('figure');
			for(let i = 0; i < image_fit.length; i++ ){
				const this_image = image_fit[i].getElementsByTagName('img')[0];
				const image_data = this_image.dataset.srcset;
				const image_src = this_image.getAttribute('src');
				image_fit[i].classList.add('ie-bg');
				if(image_data){
					image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
				}else{
					image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
				}
			}
		}
		else
		{
			//console.log('other browser');
		}
		return false;
	}

	msieversion();

	$(".form-module-wrapper form").addClass('animate-fade top');
	$(".text-modules-wrapper .text-modules").addClass('animate-fade top');

	let Header = document.getElementById('header');

	let BurgerMenu = document.getElementById('burgerMenu');
	let NavigationBox = document.getElementById('navigationBox');

	let WeddingsBtn = document.getElementById('RfpWeddingsBtn');
	let BookingBox = document.getElementById('bookBox');

	let BookingMenu = document.getElementById('bookingMenu');
	let WeddingsMenu = document.getElementById('weddingsMenu');
	let BoxBooking = document.getElementById('boxBooking');
	let BoxFormRfp = document.getElementById('boxFormRfp');

	let BookYourStay = document.getElementById('bookYourStay');

	//header click events to open boxes
	BurgerMenu.addEventListener('click', function(e){
		e.preventDefault();
		for(let i = 0 ; i < allBoxesLength; i++){
			if(allBoxes[i] !== NavigationBox){
				allBoxes[i].classList.remove('open');
			}
		}
		if(!this.classList.contains('open')){
			this.classList.add('open');
			Header.classList.add('open-menu');
			this.getElementsByClassName('text')[0].innerHTML = 'Close';
			NavigationBox.classList.add('open');
		} else {
			this.classList.remove('open');
			Header.classList.remove('open-menu');
			this.getElementsByClassName('text')[0].innerHTML = 'Menu';
			NavigationBox.classList.remove('open');
			BookingBox.classList.remove('open');
			BookingBox.classList.remove('bg-wedding');
			BookingBox.classList.add('active');
			WeddingsBtn.classList.remove('open');
			WeddingsMenu.classList.remove('active');
			BoxFormRfp.classList.remove('active');
			BookingMenu.classList.remove('active');
			BoxBooking.classList.remove('active');
		}
	});

	if(WeddingsBtn){
		WeddingsBtn.addEventListener('click', function(){
			this.classList.add('open');
			BurgerMenu.classList.add('open');
			BurgerMenu.getElementsByClassName('text')[0].innerHTML = 'Close';
			BookingBox.classList.add('open');
			BookingBox.classList.add('bg-wedding');
			BookingBox.classList.remove('active');
			WeddingsMenu.classList.add('active');
			BoxFormRfp.classList.add('active');
			BookingMenu.classList.remove('active');
			BoxBooking.classList.remove('active');
		});
	}

	if(BookingMenu){
		BookingMenu.addEventListener('click', function(e){
			e.preventDefault();
			BookingBox.classList.remove('bg-wedding');
			this.classList.add('active');
			BoxBooking.classList.add('active');
			WeddingsMenu.classList.remove('active');
			BoxFormRfp.classList.remove('active');
		});
	}

	if(WeddingsMenu){
		WeddingsMenu.addEventListener('click', function(e){
			e.preventDefault();
			BookingBox.classList.add('bg-wedding');
			this.classList.add('active');
			BoxFormRfp.classList.add('active');
			BookingMenu.classList.remove('active');
			BoxBooking.classList.remove('active');
		});
	}

	if(BookYourStay){
		BookYourStay.addEventListener('click', function(e){
			e.preventDefault();
			this.classList.add('open');
			BurgerMenu.classList.add('open');
			BurgerMenu.getElementsByClassName('text')[0].innerHTML = 'Close';
			BookingBox.classList.add('open');
			BookingBox.classList.remove('active');
			WeddingsMenu.classList.remove('active');
			BoxFormRfp.classList.remove('active');
			BookingMenu.classList.add('active');
			BoxBooking.classList.add('active');
		});
	}

	$(document).ready(function () {

		let promise = document.querySelector('video').play();

		if (promise !== undefined) {
			promise.then(_ => {
				// Autoplay started!
			}).catch(error => {
				// Autoplay was prevented.
				// Show a "Play" button so that user can start playback.
			});
		}

		setTimeout(function(){
			$('#videoTexture')[0].play();
		}, 1000);

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//To create after event
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		};

		$('#arriveInput').on('change', function(){
			start = $(this).val();
			$('.calendar-block').datepicker("setDate", start);
			$(this).attr('value', start);
		});

		$('#departureInput').on('change', function(){
			end = $(this).val();
			$('.calendar-block').datepicker("setDate", end);
			$(this).attr('value', end);
		});

		$('.dates_iputs').on('click', function(){
			$('.calendar-block').addClass('active');
		})
		$('.top-content, #content').on('click', function(){
			$('.calendar-block').removeClass('active');
		})

		$('.calendar-block').datepicker({
			changeMonth: true,
			dateFormat: 'mm-dd-yy',
			numberOfMonths: 2,
			beforeShowDay: function (date) {
				$.datepicker._defaults.dateFormat = "mm-dd-yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				let arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				let departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				let selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
					opencheck = 1;
					firstClick = 0;
				}

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);

			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		});

		$("#booking-form").submit(function(e){
			e.preventDefault();
			let checkin = $('#arriveInput').val();
			checkin = convertDateFormat(checkin);
			let checkout = $('#departureInput').val();
			checkout = convertDateFormat(checkout);
			let formaction = $("#booking-form").attr('action');
			let newurl = formaction+ '?checkin='+checkin +'&checkout='+checkout;
			 newurl = decorateUrlGA4(newurl);
			 window.open(newurl,'_blank');
			//newurl = decorateUrlGA4New(newurl);
		});

		function convertDateFormat(string) { 
			var info = string.split('-');
			return info[2] + '-' + info[0] + '-' + info[1];
		}
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		// let widthPage = $('#home').width();
		// let heightImage = $('#home .top-content').height();
		// if(widthPage >= 1500) {
		// 	$('#home .intro-content-home').css( { 'margin-top' : heightImage+'px'} );
		// } else {
		// 	$('#home .intro-content-home').css( { 'margin-top' : '0px'} );
		// }

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});
	};

	// $(window).resize(function() {
	// 	let widthPage = $('#home').width();
	// 	let heightImage = $('#home .top-content').height();
	// 	if(widthPage >= 1500) {
	// 		$('#home .intro-content-home').css( { 'margin-top' : heightImage+'px'} );
	// 	} else {
	// 		$('#home .intro-content-home').css( { 'margin-top' : '0px'} );
	// 	}
	// });

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function menuLinksInteraction(){
	if(document.getElementsByClassName('menu-gallery-item').length > 0){
		//ini
		let ini = 0;
		let allPrimaryA = document.getElementById('primary-nav').getElementsByTagName('a');
		let allGalleryI = document.getElementsByClassName('menu-gallery-item');
		for(let i = 0;i < allPrimaryA.length; i++ ){
			if(allPrimaryA[i].classList.contains('active')){
				allGalleryI[i].classList.add('active');
				ini = 1;
			}
		}
		if(ini == 0){
			allGalleryI[0].classList.add('active');
		}
		//hover
		for(let i = 0;i < allPrimaryA.length; i++ ){
			allPrimaryA[i].addEventListener('mouseenter', function(e){
				for(let j = 0;j < allGalleryI.length; j++){
					allGalleryI[j].classList.remove('active')
				}
				allGalleryI[i].classList.add('active')
			})
		}
	}
}